import React, { useEffect, useState } from 'react'
import Card from "../../../core/Card";
import style from "../../../views/style.module.css";
import Input from "../../../core/Inputs/DefaultInput";
import { useTranslation } from "react-i18next";


const DuplicateWithName = ({
    open,
    onSuccess,
    onCancel,
    data,
    title,
    fieldName,
    fieldPlaceholder,
    fieldErrorMessage,
    btnName,
    defaultValue
}) => {

    //States
    const [inputDataString, setInputDataString] = useState('')
    const [error, setError] = useState(false)
    const [dataValues, setDataValues] = useState(null)
    const { t } = useTranslation();

    //Functionalities
    const handleClear = () => {
        setInputDataString('')
        setError(true)
    }

    const handleOnSuccess = () => {
        if (!error) {
            onSuccess(dataValues, inputDataString)
        }
    }

    const handleOnCancel = () => {
        onCancel()
        setInputDataString('')
        setError(false)
        setDataValues(null)
    }

    //Effects
    useEffect(() => {
        setDataValues(data)
    }, [data])

    useEffect(() => {
        setInputDataString(defaultValue)
    }, [defaultValue, open])


    return (
        <>
            <div className={`customvar-modal modal custom-modal fade deleteModal ${open ? 'show' : ''}`} style={{ display: `${open ? 'block' : 'none'}` }} id="duplicateSurveyModal" tabIndex={-1} aria-labelledby="duplicate-modalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-setting-medium " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card} >
                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>{title}</h3>
                                            </div>
                                            <div className="mb-3 mb-md-4 position-relative">
                                                <div className='mb-1'>{fieldName}</div>
                                                <Input
                                                    type='text'
                                                    view='outlined'
                                                    dense={false}
                                                    color='default'
                                                    label={''}
                                                    placeholder={fieldPlaceholder}
                                                    clearButton={true}
                                                    success={false}
                                                    error={false}
                                                    fill={true}
                                                    errorHelperText={null}
                                                    className={"formsinput"}
                                                    value={inputDataString}
                                                    onChange={(e) => { setInputDataString(e.target.value) }}
                                                    onClear={() => handleClear()}
                                                />
                                                {error && <div className="validation-msg">{fieldErrorMessage}</div>}
                                            </div>
                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-primary" onClick={() => handleOnSuccess(data)}>{btnName ?? 'Save'}</button>
                                                <button type="button" className="btn btn-bordered ms-3" onClick={() => handleOnCancel()}>{t('survey.customVariable.cancel')}</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`modal-backdrop fade ${open ? 'show' : ''}`} style={{ display: `${open ? 'block' : 'none'}` }}></div>
        </>
    )
}

export default DuplicateWithName